import { useState, useEffect, useRef, useCallback } from 'react';
import { db, auth } from '../firebase';
import { doc, setDoc } from 'firebase/firestore';

// Simple onboarding state with debounced Firestore autosave to /users/{uid}/onboardingDraft
export default function useOnboardingState(initial = {}) {
  const [state, setState] = useState(() => ({
    ownerEmail: '',
    company: {},
    locations: [],
    hours: {},
    roles: [],
    people: [],
    ...initial,
  }));

  const timer = useRef(null);

  const saveDraft = useCallback(async (payload) => {
    try {
      const user = auth.currentUser;
      if (!user) return;
      const ref = doc(db, `users/${user.uid}`);
      await setDoc(ref, { onboardingDraft: payload }, { merge: true });
    } catch (err) {
      console.error('Failed to save onboarding draft:', err);
    }
  }, []);

  // debounce autosave
  useEffect(() => {
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      saveDraft(state);
    }, 800);
    return () => {
      if (timer.current) clearTimeout(timer.current);
    };
  }, [state, saveDraft]);

  const setField = (key, value) => {
    setState((s) => ({ ...s, [key]: value }));
  };

  const merge = (patch) => setState((s) => ({ ...s, ...patch }));

  const clearDraft = async () => {
    setState({ ownerEmail: '', company: {}, locations: [], hours: {}, roles: [], people: [] });
    try {
      const user = auth.currentUser;
      if (!user) return;
      const ref = doc(db, `users/${user.uid}`);
      await setDoc(ref, { onboardingDraft: null }, { merge: true });
    } catch (err) {
      console.error('Failed to clear onboarding draft:', err);
    }
  };

  return { state, setField, merge, clearDraft };
}
